'use client';

import 'swiper/css';
import 'swiper/css/autoplay';

import classNames from 'classnames';
import Link from 'next/link';
import { useEffect } from 'react';
import { Autoplay } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';

// FIXME: 소개페이지 변경 할 때 로띠로 다시 제작 예정
// import main1 from '/public/lottie/main1.json';
// import main2 from '/public/lottie/main2-1.json';
// import main3 from '/public/lottie/main3.json';
import LottieSection from '@/app/main/ui/lottieSection';
import { handleSendGAEvent } from '@/utils/google';
import { convertCdnUrl } from '@/utils/js/condition';

import styles from './main.module.scss';

export default function MainContent() {
  const mainVisualText = [
    '요즘 거래 많은',
    '신고가 나온',
    '오늘 뉴스에 나온',
    '정책 영향 받는',
    '사도 될지 궁금한',
    '눈여겨보던',
  ];

  const housingTaste = [
    { text: '시원한 테라스', url: convertCdnUrl('/main/ht01.svg') },
    { text: '역세권', url: convertCdnUrl('/main/ht02.svg') },
    { text: '해가 잘 드는', url: convertCdnUrl('/main/ht03.svg') },
    { text: '시원한 뷰', url: convertCdnUrl('/main/ht04.svg') },
    { text: '여유로운 준비', url: convertCdnUrl('/main/ht05.svg') },
    { text: '깨끗한 신축', url: convertCdnUrl('/main/ht06.svg') },
    { text: '반려동물 가능', url: convertCdnUrl('/main/ht07.svg') },
    { text: '주차 가능', url: convertCdnUrl('/main/ht08.svg') },
    { text: '초품아', url: convertCdnUrl('/main/ht09.svg') },
  ];

  //GA4
  const LinkToPlayStoreTop = () => {
    handleSendGAEvent('town_homepage_top_playstore_btn', {
      event_category: 'town_homepage',
    });
    window.open('https://play.google.com/store/apps/details?id=kr.co.proptier.town', '_blank');
  };

  const LinkToAppStoreTop = () => {
    handleSendGAEvent('town_homepage_top_appstore_btn', {
      event_category: 'town_homepage',
    });
    window.open('https://apps.apple.com/kr/app/id6736497502', '_blank');
  };

  const LinkToPlayStoreBottom = () => {
    handleSendGAEvent('town_homepage_bottom_playstore_btn', {
      event_category: 'town_homepage',
    });
    window.open('https://play.google.com/store/apps/details?id=kr.co.proptier.town', '_blank');
  };

  const LinkToAppStoreBottom = () => {
    handleSendGAEvent('town_homepage_bottom_appstore_btn', {
      event_category: 'town_homepage',
    });
    window.open('https://apps.apple.com/kr/app/id6736497502', '_blank');
  };

  useEffect(() => {
    handleSendGAEvent('page_view', {
      event_category: 'town_homepage',
      page_title: 'town_homepage',
      page_referrer: window.location.href,
    });
  }, []);

  return (
    <div>
      <section className={styles.main_visual}>
        <div className={classNames('inner', styles.inner)}>
          <div className={styles.text_wrap}>
            <Swiper
              className={styles.swiper}
              modules={[Autoplay]}
              slidesPerView={'auto'}
              autoplay={{ delay: 3000, disableOnInteraction: false }}
              loop={true}
              direction="vertical"
            >
              {mainVisualText.map((text, index) => (
                <SwiperSlide key={index} className={styles.swiper_slide}>
                  <p>{text}</p>
                </SwiperSlide>
              ))}
            </Swiper>
            <p>우리 동네 부동산</p>
            <p>매일 확인하기</p>
          </div>
          <div className={styles.app_down_btn_wrap}>
            <Link
              href="/"
              className={classNames(styles.download_btn, styles.apple)}
              onClick={LinkToAppStoreTop}
            >
              <span className="text_blind">앱 다운로드 버튼 - 애플 앱 스토어</span>
            </Link>
            <Link
              href="/"
              className={classNames(styles.download_btn, styles.google)}
              onClick={LinkToPlayStoreTop}
            >
              <span className="text_blind">앱 다운로드 버튼 - 구글 플레이 스토어</span>
            </Link>
          </div>
          <div className={styles.scroll_guide}>
            <i className={styles.icon_arrow}>
              <span className="text_blind">흰색 아래 방향 화살표 아이콘</span>
            </i>
          </div>
        </div>
      </section>
      <LottieSection
        isBgOrange={false}
        // lottieData={main1}
        imgUrl={convertCdnUrl('/main_2602/main1.png')}
        subject="매경뉴스"
        title={
          <>
            <p>매일경제를 통해</p>
            <p>부동산 소식도 확인하세요</p>
          </>
        }
        text={
          <>
            <p>대한민국 대표 언론사 {`"매일경제"`}의​</p>
            <p>공신력 있는 부동산 뉴스 매일 보기​</p>
          </>
        }
      />
      <LottieSection
        isBgOrange={true}
        reverse={true}
        imgUrl={convertCdnUrl('/main_2602/main2.png')}
        subject="안심케어"
        title={
          <>
            <p>안심하며 계약하고</p>
            <p>안전하게 사는 안심케어</p>
          </>
        }
        text={
          <>
            <p>등기부터 법률 상담지원까지​</p>
            <p>당신의 부동산을 지켜드려요</p>
          </>
        }
      />
      <LottieSection
        isBgOrange={false}
        // lottieData={main1}
        imgUrl={convertCdnUrl('/main_2602/main3.png')}
        subject="피드"
        title={
          <>
            <p>매일 새로운 집 발견!</p>
            <p>갤러리로 한 눈에 알아보세요</p>
          </>
        }
        text={
          <p>
            <span>매일 전국에서 등록된 5만여 개의</span>
            <span> 이실장 신규 매물을 빠르게 확인</span>
          </p>
        }
      />
      <LottieSection
        isBgOrange={true}
        reverse={true}
        subject="테마"
        // lottieData={main2}
        imgUrl={convertCdnUrl('/main_2602/main4.png')}
        title={
          <>
            <p>다양한 테마를 통해</p>
            <p>더욱 쉽게 집을 찾아보세요​</p>
          </>
        }
        text={
          <>
            <p>해가 잘드는 남향집, 로망이 가득한 복층</p>
            <p>원하는 조건을 테마에서 골라보세요​</p>
          </>
        }
      />
      <LottieSection
        subject="사진 매물"
        // lottieData={main2}
        imgUrl={convertCdnUrl('/main_2602/main5.png')}
        title={
          <>
            <p>사진으로 새로운 집을</p>
            <p>더 크게 확인해보세요</p>
          </>
        }
        text={<p>다양한 매물도 보고​ 사진도 간편하게 확인하기​</p>}
      />
      <div className={styles.bottom}>
        <div className={styles.pad}>
          <div className={styles.text}>
            <b>매일 확인하는 우리 동네 부동산,</b>
            <span>이실장</span>
          </div>
          <div className={styles.app_down_btn_wrap}>
            <Link
              href="/"
              className={classNames(styles.download_btn, styles.apple)}
              onClick={LinkToAppStoreBottom}
            >
              <span className="text_blind">앱 다운로드 버튼 - 애플 앱 스토어</span>
            </Link>
            <Link
              href="/"
              className={classNames(styles.download_btn, styles.google)}
              onClick={LinkToPlayStoreBottom}
            >
              <span className="text_blind">앱 다운로드 버튼 - 구글 플레이 스토어</span>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
